/* mb-buy — the buy box on real Shopify data (replaces the source's Kaching widget + its variant-bound scripts).
   - tier click (.kaching-bundles__bar-main / radio) selects a tier, repaints the badge + Add-to-cart prices;
   - the product form submit adds that tier (variant × quantity) with ONE /cart/add.js, then goes to checkout (or cart);
   - fails closed: an unavailable tier cannot be added and the page says why (role="alert").
   The pricing-cards section's own script drives this box through the same DOM (it clicks .kaching-bundles__bar-main). */
(function () {
  'use strict';
  var root = document.querySelector('[data-mb-buy]');
  if (!root) return;
  var data;
  try { data = JSON.parse(root.querySelector('[data-mb-buy-data]').textContent); } catch (e) { return; }
  window.MB_BUY = data;   // the cart drawer (mb-cart.js) reads tiers, variants and the money format from here
  var errEl = root.querySelector('[data-mb-error]');
  var bars = Array.prototype.slice.call(root.querySelectorAll('.kaching-bundles__bar'));
  var busy = false;

  function money(cents) {
    var fmt = data.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    function grp(x, d, t, s) { var p = x.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(s); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return grp(n, 2, "'", '.');
      return grp(n, 2, ',', '.');
    });
  }

  function tierInfo(t) {
    var cfg = data.tiers[t - 1];
    var v = data.variants[cfg.variant] || data.variants[data.defaultVariant];
    if (!v) return null;
    var q = Math.max(1, parseInt(cfg.qty, 10) || 1);
    var p = v.price * q, c;
    if (v.compare && v.compare > v.price) c = v.compare * q;
    else if (cfg.strike !== null && cfg.strike !== '' && cfg.strike !== undefined) c = Math.round(cfg.strike * 100) * q;
    else c = v.price * 2 * q;
    return { variant: v, qty: q, price: p, compare: c, pct: c > 0 ? Math.round(100 - p * 100 / c) : 0 };
  }

  function setText(sel, txt) {
    document.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; });
  }

  function paint(t) {
    var i = tierInfo(t);
    if (!i) return;
    setText('[data-badge-price]', money(i.price));
    setText('[data-badge-compare]', money(i.compare));
    setText('[data-badge-pct]', i.pct + '%');
    setText('.mb-atc-btn-price', money(i.price));
    setText('.mb-atc-btn-compare', money(i.compare));
  }

  function select(t) {
    data.selected = t;
    bars.forEach(function (b) {
      var on = String(b.getAttribute('data-tier')) === String(t);
      b.classList.toggle('kaching-bundles__bar--selected', on);
      var r = b.querySelector('input[type="radio"]'); if (r) r.checked = on;
    });
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    paint(t);
  }

  bars.forEach(function (b) {
    var t = parseInt(b.getAttribute('data-tier'), 10);
    b.addEventListener('click', function () { select(t); });   // no preventDefault: the pricing-cards script clicks the radio, and a cancelled radio click reverts its checked state
    var main = b.querySelector('.kaching-bundles__bar-main');
    if (main) main.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(t); } });
  });

  function fail(msg) {
    if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
  }

  function add(btn) {
    if (busy) return;
    var i = tierInfo(data.selected);
    if (!i || !i.variant.available) { fail(data.msg.unavailable); return; }
    busy = true;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.remove('hidden'); }
    var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root_ + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: i.variant.id, quantity: i.qty }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || !j || !j.items) throw new Error((j && (j.description || j.message)) || 'add failed'); return j; });
    }).then(function () {
      if (data.after === 'drawer' && window.MBCart) {   // the source's step: the "Your order" drawer, checkout from there
        busy = false;
        if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); var sp2 = btn.querySelector('.loading__spinner'); if (sp2) sp2.classList.add('hidden'); }
        return window.MBCart.open();
      }
      window.location.href = root_ + (data.after === 'cart' ? 'cart' : 'checkout');
    }).catch(function (e) {
      busy = false;
      if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('loading'); var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.add('hidden'); }
      fail(data.msg.failed + (e && e.message && e.message !== 'add failed' ? ' (' + e.message + ')' : ''));
    });
  }

  // the product form's submit (main Add to cart; the pricing cards click it too)
  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); add(f.querySelector('[type="submit"]')); }, true);
  });
  document.querySelectorAll('.product-form__submit').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); add(b); }, true);
  });

  // videos: a block's video URL setting is stored as data-mb-src (blank = cover image only)
  document.querySelectorAll('video[data-mb-src]').forEach(function (v) {
    var s = v.getAttribute('data-mb-src'); if (s) v.src = s;
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; } });
  select(data.selected);
})();
